import { Formik } from 'formik';
import { initialValuesCheckbook, validationSchemaCheckbook } from './CreateCheckbookValidator';
import Form from "./CreateCheckbook";
import { useAxios } from '../../../../context/AxiosHookContext';
import { useNotification } from '../../../../context/NotificationContext';

const FormCreateCheckbook = ({ valuesToEdit, onClose, getValues }) => {

    const axios = useAxios();
    const { showSnackbar } = useNotification();

    const handleSubmit = async (checkbook) => {

        try {

            if (checkbook._id) {
                await axios.put(`/checkbook/byId/${checkbook._id}`, checkbook)
            }  else {
                await axios.post(`/checkbook/create`, checkbook)
            }

            showSnackbar({ severity: "success", title: "Cuenta de banco", message: "Se ha guardado de forma exitosa." });

            getValues();

        } catch (error) {
            const message = error?.response?.data?.message || error?.message || "Ha ocurrido un error al crear."
            showSnackbar({ severity: "error", title: "Cuenta de banco", message })
        }
    }

    const getInitialValues = () => {
        return (valuesToEdit && Object.keys(valuesToEdit).length) > 0 ? valuesToEdit : initialValuesCheckbook
    }
    return (
        <Formik
            validationSchema={validationSchemaCheckbook}
            initialValues={getInitialValues()}
            onSubmit={handleSubmit}
        >
            <>
                <Form onClose={onClose} />
            </>
        </Formik>
    )
}

export { FormCreateCheckbook }